import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0A0A0A] px-4 py-14 sm:px-6" data-id="element-116" data-mp="19ivlq3plplne">
      <div className="mx-auto max-w-3xl text-center" data-id="element-117" data-mp="208caozdh8xmx">
        <h2 className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-118" data-mp="209x5mq3peilb">PROFES DE TELAS RESUELTO™</h2>
        <p className="mt-4 text-sm text-white/70 sm:text-base" style={{
        fontWeight: "600"
      }} data-id="element-119" data-mp="2a5qsb2b4zsgt">
          El sistema de clases N°1 para profes de telas en Argentina.
        </p>
        <p className="mt-2 text-sm text-white/70 sm:text-base" style={{
        fontSize: "12px",
        fontWeight: "300"
      }} data-id="element-120" data-mp="1mgfpzge51q0k">
          Porque enseñar en telas no debería costarte todas las noches de la semana.
        </p>

        <ul className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-8" data-id="element-121" data-mp="1w8235ia1dz5y">
          <li data-id="element-122" data-mp="1rdeftmqrrasy">
            <a href="mailto:soporterecursosfitnesspro@gmail.com" className="break-all text-sm font-medium text-dorado transition-colors hover:text-white" data-id="element-123" data-mp="13peq8q571qfy">
              📧 soporterecursosfitnesspro@gmail.com
            </a>
          </li>
          <li data-id="element-124" data-mp="1eg9e2po5gtn1">
            <a href="https://instagram.com/recursos.fitness.pro" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-dorado transition-colors hover:text-white" data-id="element-125" data-mp="1ijntpf86f7zy">
              📲 @recursos.fitness.pro
            </a>
          </li>
        </ul>

        <p className="mt-10 border-t border-white/10 pt-6 text-xs leading-relaxed text-white/45" data-id="element-126" data-mp="vk9i73s1x5y6">
          © Recursos Fitness Pro 2026 — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}